import { useState, useCallback, useContext } from 'react';
import { Frame } from '@shopify/polaris';
import { Outlet, useNavigate } from 'react-router-dom';
import logo from '../assests/Karbon logo.svg'
import Topbar from '../Topbar';
import Sidebar from '../Sidebar';
import { AuthContext } from '../../providers/AuthProvider'

import { useEffect } from 'react';

const ProtectedLayout = () => {
  let navigate = useNavigate();
  const { authState, isAuthenticated } = useContext(AuthContext)
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
  const toggleMobileNavigationActive = useCallback(
    () =>
      setMobileNavigationActive(
        (mobileNavigationActive) => !mobileNavigationActive,
      ),
    [],
  );


  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", { replace: true })
    }
  }, [isAuthenticated, navigate])


  return (
    <Frame
      logo={{
        width: 30,
        topBarSource: logo,
        contextualSaveBarSource: logo,
      }}
      navigation={(<Sidebar />)}
      topBar={<Topbar toggleMobileNavigation={toggleMobileNavigationActive} />}
      showMobileNavigation={mobileNavigationActive}
      onNavigationDismiss={toggleMobileNavigationActive}
    >
      <Outlet />
      {
        authState.authenticated && <Outlet />
      }
    </Frame>
  )
}

export default ProtectedLayout;